import { Link } from 'react-router-dom';
import useThemeStore from 'Theme/store';

const Tool = ({ Icon, title, desc, to, group, fromColor }) => {
  const { theme: themeValue } = useThemeStore();
  return (
    <Link to={to} className="flex relative">
      <div className="flex-1 text-left font-figtree">
        <div
          className={`flex-1 ${
            themeValue === 'dark' ? 'bg-night-black' : 'bg-white'
          } rounded-md transition hover:shadow-md overflow-hidden md:max-w-1lg cursor-pointer md:flex relative transform hover:scale-105 mr-4`}
        >
          {Icon && (
            <div
              className={`md:flex-shrink-0 flex justify-start items-center ml-8 text-${
                fromColor ? fromColor : 'green-500'
              }`}
            >
              <Icon className="h-16 w-16 mb-4 mt-4" />
            </div>
          )}
          <div className="p-4">
            <div
              className={`uppercase tracking-wide text-sm text-${
                fromColor ? fromColor : 'green-500'
              } font-semibold leading-none`}
            >
              {group || ''}
            </div>
            <div
              className={`block text-lg xl:text-xl 2xl:text-2xl leading-tight font-base text-battleship-gray dark:text-quicksilver`}
            >
              {title}
            </div>
            <p
              className={`mt-1 pr-1 text-base ${
                themeValue === 'dark'
                  ? 'dark:text-crystal-bell'
                  : 'text-cool-gray'
              }  `}
            >
              {desc}{' '}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Tool;
